const availableLanguages = [
    {
        label: 'Inglês',
        value: 'english'
    },
    {
        label: 'Espanhol',
        value: 'spanish'
    },
    {
        label: 'Francês',
        value: 'french'
    },
    {
        label: 'Italiano',
        value: 'italian'
    },
    {
        label: 'Japonês',
        value: 'japanese'
    },
    {
        label: 'Mandarim',
        value: 'mandarin'
    },
    {
        label: 'Árabe',
        value: 'arabian'
    },
    {
        label: 'Libanês',
        value: 'libanese'
    },
    {
        label: 'Outros',
        value: 'others'
    }
]

export default availableLanguages
